<div class="flex flex-col gap-8">
  @if (conflictingDependencies().usualConflicts.length) {
    <ng-container
      *ngTemplateOutlet="
        conflictingDependenciesTemplate;
        context: {
          $implicit: conflictingDependencies().usualConflicts,
          type: ConflictingDependencyType.USUAL,
        }
      "
    ></ng-container>
  }

  @if (conflictingDependencies().circularConflicts.length) {
    <ng-container
      *ngTemplateOutlet="
        conflictingDependenciesTemplate;
        context: {
          $implicit: conflictingDependencies().circularConflicts,
          type: ConflictingDependencyType.CIRCULAR,
        }
      "
    ></ng-container>
  }

  @if (newDependencies().length) {
    <ng-container
      *ngTemplateOutlet="newDependenciesTemplate; context: { $implicit: newDependencies() }"
    ></ng-container>
  }

  @if (
    conflictingDependencies().usualConflicts.length ||
    conflictingDependencies().circularConflicts.length
  ) {
    <div class="flex items-center gap-2 p-2 rounded text-neutral-700 bg-neutral-50">
      <i class="ph ph-warning text-yellow-500"></i>
      <span class="text-xs"
        >Please check and fix any broken usages after copying the resource.</span
      >
    </div>
  }
</div>

<ng-template
  #conflictingDependenciesTemplate
  let-conflictingDependencies
  let-type="type"
>
  @let dependencyWord = conflictingDependencies.length > 1 ? 'dependencies' : 'dependency';

  <div class="text-xs text-neutral-500">
    <span class="font-semibold">{{ resourceName }}</span> uses resources from libraries which
    <span class="font-semibold">{{
      type === ConflictingDependencyType.USUAL
        ? `already exist in the ${targetAppName} project but with a different version.`
        : `cannot be added because it would create a circular dependency.`
    }}</span>
    <div>
      Below {{ dependencyWord }}, along with any existing child dependencies, will
      <span class="font-semibold">NOT</span> be copied to {{ targetAppName }} project.
    </div>
  </div>

  <div class="text-xs text-red-500 font-semibold">
    @for (
      conflictingDependency of conflictingDependencies;
      track conflictingDependency.buildAppId
    ) {
      <div>{{ conflictingDependency.buildAppName }} {{ conflictingDependency.buildTag }}</div>
    }
  </div>
</ng-template>

<ng-template
  #newDependenciesTemplate
  let-newDependencies
>
  @let dependencyWord = newDependencies.length > 1 ? 'dependencies' : 'dependency';

  <div>
    @if (hasConflicts()) {
      <div class="font-bold mb-1">New Dependencies</div>
    }

    <div class="text-xs">
      <span class="font-bold text-neutral-500">{{ resourceName }}</span> uses resources from
      libraries which
      <span class="font-bold text-neutral-500"
        >do not exist in the {{ targetAppName }} project.</span
      >
      <div>
        Copying {{ resourceName }} will add the following {{ dependencyWord }},
        <span class="font-bold text-neutral-500">along with any existing child dependencies</span>,
        to the {{ targetAppName }} project.
      </div>
    </div>
  </div>

  <div class="text-xs font-semibold">
    @for (newDependencies of newDependencies; track newDependencies.buildApplicationId) {
      <div>{{ newDependencies.buildApplicationName }} {{ newDependencies.buildTag }}</div>
    }
  </div>
</ng-template>
